import React from "react";

export default function Section13() {
  const processSteps = [
    {
      title: "End-to-End Development",
      description: "From planning to launch, we provide complete Shopify development services tailored for growing Texas brands.",
    },
    {
      title: " In-House UI/UX Designers",
      description: "Our designers craft intuitive, branded interfaces that improve customer engagement and maximize conversions.",
    },
    {
      title: "Performance-Driven Builds",
      description: " Fast-loading, mobile-optimized, and SEO-ready Shopify stores built to enhance Texas business growth",
    },
    {
      title: " Long-Term Support",
      description: "Continuous post-launch support and updates to help Texas businesses scale efficiently over time.",
    },
    
  ];

  return (
    <div className="w-full Section13">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Why Texas Businesses Choose Mean3.
        </h2>
        <p className="text-[#373737] text-sm md:text-base leading-[22px] mb-8">
          Our Shopify development process is designed to ensure clarity, collaboration, and high-quality output at every step.
        </p>

        <div className="boxes flex flex-wrap justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] w-[100%] mx-auto">
          {processSteps.map((step, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
                }`}
            >
              <h3 className="md:text-[25px] text-[20px] font-bold leading-[30px] mb-3">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm leading-[22px] font-open">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
